import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { User } from '../_models/user.model';
import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs/operators';

const baseURL = environment.baseURL;
const API_USERS_URL = environment.baseURL + 'users/';

@Injectable({
  providedIn: 'root'
})
export class AuthattorneyService {

  //private currentUserSubject: BehaviorSubject<User>;

  currentUser: BehaviorSubject<User> = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
  currentUser$ = this.currentUser.asObservable();

  constructor(private myRoute: Router, private http: HttpClient) {
  }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('currentUserToken')
    })
  };

  // Authentication/Authorization
  login(email: string, password: string): Observable<any> {  
    const ipAddress=null  
    return this.http.post<User>(baseURL + 'AttorneyUser/Login', { email, password, ipAddress }).pipe(map(user => {
      // login successful if there's a jwt token in the response       
      if (user && user.succeeded) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('currentUser', JSON.stringify(user.data));
        this.currentUser.next(user.data);
      }
      return user;
    }));
  }


  getUserDetail() {
    return this.currentUser.asObservable();
  }


  verifyEmail(data) {
    var token = {
      'user_token': data
    }
    return this.http.post<any>(baseURL + 'verifyemail/', token);
  }


  verifyToken(data) {
    let token = { 'token': data };
    return this.http.post<any>(API_USERS_URL + 'verify/', token);
  }

  /*
   * Submit set new password request
   *
   * @param {string} email
   * @returns {Observable<any>}
   */
  setPassword(data) {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.post<any>(baseURL + 'User/RestPassword', data, { headers: httpHeaders });
  }

  getUserByToken(): Observable<User> {
    const httpHeaders = new HttpHeaders();
    return this.http.get<User>(baseURL, { headers: httpHeaders });
  }

  public register(responce): Observable<any> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.post(baseURL+'AttorneyUser/CreateAttorneyUser', responce, { headers: httpHeaders });
  }
  /*
   * Submit forgot password request
   *
   * @param {string} email
   * @returns {Observable<any>}
   */
  public requestPassword(email: string): Observable<any> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.post<User>(API_USERS_URL + 'forgotPassword', { 'email': email, 'type': 'admin' }, { headers: httpHeaders });
  }


  getAllUsers(): Observable<User[]> {
    return this.http.get<User[]>(API_USERS_URL);
  }

  getUserById(userId: any): Observable<User> {
    return this.http.get<User>(API_USERS_URL + `userProfile/${userId}`);
  }


  // DELETE => delete the user from the server
  deleteUser(userId: number) {
    const url = `${API_USERS_URL}/${userId}`;
    return this.http.delete(url);
  }

  editUser(data) {

    return this.http.put<any>(API_USERS_URL, data).pipe(map(user => {
      // login successful if there's a jwt token in the response
      if (user && user.status === 1) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('currentUser', JSON.stringify(user.items));
        this.currentUser.next(user.items);
      }
      return user;
    }));
  }


  // UPDATE => PUT: update the user on the server
  updateUser(_user: User): Observable<any> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.put(API_USERS_URL, _user, { headers: httpHeaders });
  }

  // CREATE =>  POST: add a new user to the server
  createUser(user: User): Observable<User> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.post<User>(API_USERS_URL, user, { headers: httpHeaders });
  }

  // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
  // items => filtered/sorted result
  findUsers(queryParams): Observable<QueryResultsModel> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.post<QueryResultsModel>(API_USERS_URL, queryParams, { headers: httpHeaders });
  }

  userChartCount() {
    return this.http.get(API_USERS_URL + 'getMonthWiseCount');
  }

  removeImage(obj) {
    return this.http.post<any>(API_USERS_URL + 'removeImage',obj);
  }

  changePassword(_user) {
    const httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem(environment.authTokenKey)
    })
    return this.http.post(API_USERS_URL + 'changepassword', _user, { headers: httpHeaders });
  }




  /*
   * Handle Http operation that failed.
   * Let the app continue.
   *
 * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: any) {
    return (error: any): Observable<any> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result);
    };
  }

  sendToken(token: string) {
    let userDetails = JSON.parse(token);
    /*if (userDetails && userDetails.data.data.userPermissionList) {
      var userToken = userDetails.data.data.token;
      localStorage.setItem("currentUserToken", userToken);
    }*/
    localStorage.setItem("currentUser", token)
  }
}
